import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../colorVars';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { Body2, fontSizes } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';
import style from './RepeatingField.module.css';

export const RepeatingField = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={style.container}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Repeating
      </Body2>
      <div className={style.checkboxes}>
        <CheckBox fontSize={fontSizes.body2} color={colors.lightGrey} checked={form.restartSystemOncePositionHasFlattened} onChange={value => form.setRestartSystemOncePositionHasFlattened(value)}/>
      </div>
    </div>
  );
});
